import { render, staticRenderFns } from "./ApprovalSummary.vue?vue&type=template&id=2954bbf0&scoped=true"
import script from "./ApprovalSummary.vue?vue&type=script&lang=ts"
export * from "./ApprovalSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2954bbf0",
  null
  
)

export default component.exports